import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, useAttrs, useSlots} from 'vue';
import {DisplayStore} from '@customer-portal/shared';

type TClass = Record<'class', Record<string, string | boolean>>;


interface IProps {
	dialogHeight?: 'small' | 'large'; // otherwise, use CSS on .modal-responsive-content
	loading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalResponsive',
  props: {
    dialogHeight: null,
    loading: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { dialogHeight?: 'small' | 'large', loading: boolean };

// component: ModalResponsive



const slots = useSlots();

// QDialog controls
const showModal = ref(false);

const responsiveProps = computed((): Record<string, unknown> => {
	const attrs = useAttrs();

	if(DisplayStore.isDesktop) {
		return attrs;
	}

	return {
		...attrs,
		'transition-show': 'slide-up',
		'transition-hide': 'slide-down',
		position: 'bottom',
	};
});

const hide = () => {
	showModal.value = false;
};
const show = () => {
	showModal.value = true;
};

expose({show, hide});
// end controls

const hasSlotFloatingControlBottom = computed((): boolean => {
	if(typeof slots?.['floating-control-bottom'] === 'function') {
		return (slots['floating-control-bottom']()?.length ?? 0) > 0;
	}

	return false;
});

const modalCssClasses = computed<TClass>(() => {
	const css: TClass = {
		class: {
			'add-spacer-bottom': hasSlotFloatingControlBottom.value
		},
	};

	if(props.dialogHeight === 'small' || props.dialogHeight === 'large') {
		css.class[props.dialogHeight] = true;
	}

	return css;
});

return { __sfc: true,props, slots, showModal, responsiveProps, hide, show, hasSlotFloatingControlBottom, modalCssClasses }
}

})